<template>
  <div class="case">
    <div  v-if="isScrolled9">
      <Header/>
    </div>
    <div style="height: 5em;"></div>
    <!-- Breadcrumbs -->
    <div class="Breadcrumbs">
      <div class="box">
        <a href='/' class=''>{{ $t('message.aboutBreadcrumbHome') }}</a> &gt; <a href='/about/'>{{ $t('message.aboutBreadcrumbAbout') }}</a>	</div>
    </div>

    <div class="about">
      <div class="box">
        <!-- 公司简介 -->
        <div class="about-company">
          <h2 class="about-title">{{ $t('message.companyProfile') }}</h2>
          <div class="txt">
            <p v-html="$t('message.companyProfileContent')"></p>
          </div>
          <div class="tbox">
            <h3 class="ts">
              <div class="t1">66</div>
              <div class="t2">{{ $t('message.softwareCopyright') }}</div>
            </h3>
            <h3 class="ts">
              <div class="t1">63</div>
              <div class="t2">{{ $t('message.patentApplied') }}</div>
            </h3>
            <h3 class="ts">
              <div class="t1">7</div>
              <div class="t2">{{ $t('message.patentGranted') }}</div>
            </h3>
          </div>
        </div>
        <!-- 荣誉证书 -->
        <div class="about-honer">
          <h2 class="about-title">{{ $t('message.companyHonor') }}</h2>

          <div class="list">
            <ul style="margin-top: 50px"   v-if="isScrolled" >
              <li   class="wow fadeInUp move1"><img src="https://www.yasubit.com/uploads/allimg/20210602/1-21060215112YQ.jpg" alt=""></li>
              <li class="wow fadeInUp move1"><img src="https://www.yasubit.com/uploads/allimg/20230217/1-23021F91343634.png" alt=""></li>
              <li class="wow fadeInUp move1"><img src="https://www.yasubit.com/uploads/allimg/20230109/1-2301091KU25I.jpg" alt=""></li>
              <li class="wow fadeInUp move1"><img src="https://www.yasubit.com/uploads/allimg/20230110/1-2301100Z350910.jpg" alt=""></li>
              <li class="wow fadeInUp move1"><img src="https://www.yasubit.com/uploads/allimg/20230112/1-2301121H93J10.jpg" alt=""></li>
              <li class="wow fadeInUp move1"><img src="https://www.yasubit.com/uploads/allimg/20230112/1-2301121I0415G.jpg" alt=""></li>
            </ul>
          </div>
        </div>
      </div>

    </div>
    <Footer/>
  </div>
</template>
<script>
import Header from "@/views/header.vue";
import Banner from "../components/Banner";
import Footer from "@/views/footer.vue";
export default {
  components: {
    Header,
    Banner,
    Footer
  },
  data() {
    return {
      isScrolled: false,
      isScrolled9: true,
      loading: true,
      caseList: []
    };
  },
  created() {
    document.title = this.$t('message.aboutTitle');
  },
  mounted() {

    window.addEventListener('scroll', this.handleScroll9);
    window.addEventListener("scroll", this.handleScroll1);
    window.console.log("case");
    this.$http
        .get("Cases/GetCasesAll")
        .then(response => {
          //console.log(response);
          this.caseList = response.data;
          //window.console.log(this.caseList);
          this.loading = false;
        })
        .catch(function(error) {
          window.console.log(error);
        });
  },
  methods:{


    handleScroll1() {
      // 获取滚动条距离顶部的距离
      const scrollDistance = window.scrollY || document.documentElement.scrollTop;

      // 当滚动距离大于等于500px时，设置isScrolled为true
      this.isScrolled = scrollDistance >= 550;

    },

    handleScroll9() {
      // 获取当前滚动位置
      const scrollY = window.scrollY || window.pageYOffset;

      // 可以设置一个阈值来确定何时改变isScrolled9的值
      const dis = 100;

      // 判断滚动位置是否大于阈值
      if (scrollY > dis) {
        // 向下滚动，将isScrolled9设为false
        this.isScrolled9 = false;
      } else {
        // 向上滚动，将isScrolled9设为true
        this.isScrolled9 = true;
      }
      // const scrollDistance = window.scrollY || document.documentElement.scrollTop;
      // // 当滚动距离小于等于200px时，设置isScrolled9为true
      // this.isScrolled9 = scrollDistance <=500;

    },
  }

};
</script>

<style lang="scss" scoped>

.move1 {
  opacity: 0; // 初始时透明度为0，隐藏元素
  animation: fadeIn 1s forwards, moveUp 1.2s forwards; // 1s 表示动画持续时间，forwards 表示动画结束后保持最终状态
}


@keyframes moveUp {
  to {
    transform: translateY(-50px); // 向上移动 px
  }
}

@keyframes fadeIn {
  to {
    opacity: 1; // 最终透明度为1，显示元素
  }
}

#movingBox {
  transition: transform 0.5s ease; // 添加过渡效果
}

.bounce-animation {
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0); // 初始位置和结束位置
  }

  40% {
    transform: translateY(-15px); // 上抬的高度，可以根据需要修改
  }

  60% {
    transform: translateY(-15px); // 下压的高度，可以根据需要修改
  }
}


.between{

  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.center{
  display: flex;align-items: center; text-align: center;justify-content: center
}
.one-third{
  width: 33.333333%;
  height: 50px;
  //background-color: pink;
}


.one-third-1{
  width: 33.333333%;
  height: 15em;
  //background-color: pink;
}

.one-five{
  display: flex;align-items: center; text-align: center;justify-content: center;flex-direction: column;
  width: 20%;
  height: 50px;

}



.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  //background-color: #14679f;

  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 1000px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 500px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid pink;

        img {
          width: 612px;
          height: 314px;
        }
        .content-list-abstract {
          width: 290px;
          height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            color: #e13834;
          }
          .abstract-content {
            height: 150px;
            color: #484848;
            font-size: 15px;

            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 7;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            //border: 1px solid pink;
          }
          .more {
            display: flex;
            justify-content: flex-start;
            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }
              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }
        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
</style>